import { ActivatedRoute } from '@angular/router';
import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonProfileInfoComponent } from '../common-profile-info/common-profile-info.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-trending-community',
  standalone: true,
  imports: [CommonModule, CommonProfileInfoComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './trending-community.component.html',
  styleUrls: ['./trending-community.component.scss']
})
export class TrendingCommunityComponent implements OnInit, OnChanges {

  @Input('title') title: string = 'Trending Communities';

  headerTitle: string = 'Trending Communities';
  user: any = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
  @ViewChild('businessmenusticky') menuElements: ElementRef;
  @Input() widgetDesc: string;
  @Input() suggestion: any;


  businessmenustick: boolean = false;
  constructor(private a_route: ActivatedRoute) {
   }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
        if(res.master!="NETWORK" && res.master!="TEAM" && res.menu!=null &&res.menu!=undefined){
          this.headerTitle=res.menu;
      }
   })
  }

  @HostListener('window:scroll')
  handleScroll(){
    const windowScroll = window.pageYOffset;
    if(windowScroll >= 1200){
      this.businessmenustick = true;
    } else {
      this.businessmenustick = false;
    }
  }

}
